import {
  apiContainer,
  queryBuilder,
  massageSingleRecordBeforeUpsert
} from './apiContainer'

const SLICE_API_ROOT = '/features'

const featuresApi = apiContainer.injectEndpoints({
  endpoints: build => ({
    listFeatures: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args),
      keepUnusedDataFor: 86400
    }),
    listFeatureCategories: build.query({
      query: () => `${SLICE_API_ROOT}/~/categories`,
      keepUnusedDataFor: 86400
    }),
    getOneFeature: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args),
      keepUnusedDataFor: 86400
    }),
    bulkUpdateFeatures: build.mutation({
      query: args => {
        return {
          url: SLICE_API_ROOT,
          method: 'PATCH',
          body: args
        }
      }
    }),
    upsertFeature: build.mutation({
      query: args => {
        const { id } = args
        const actualArgs = massageSingleRecordBeforeUpsert(args)

        if (id) {
          // update

          return {
            url: `${SLICE_API_ROOT}/${id}`,
            method: 'PUT',
            body: actualArgs
          }
        } //insert
        else {
          return {
            url: SLICE_API_ROOT,
            method: 'POST',
            body: actualArgs
          }
        }
      }
    }),
    deleteFeature: build.mutation({
      query: args => {
        return {
          url: `${SLICE_API_ROOT}/${args.id}`,
          method: 'DELETE'
        }
      }
    })
  }),
  overrideExisting: true
})

export const {
  // the active load query is exported to speed up the initial detail record load,
  // which happens before the ui renders anything (way b4 the react mount hooks)
  // everything else should pretty much use the lazy load queries
  useGetOneFeatureQuery,
  useLazyListFeatureCategoriesQuery,
  useLazyListFeaturesQuery,
  useUpsertFeatureMutation,
  useDeleteFeatureMutation,
  useBulkUpdateFeaturesMutation
} = featuresApi
